var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field",class:{
      error: _vm.v.$error,
      valid: !_vm.v.$invalid,
      required: _vm.v.$params.required,
    }},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_c('div',{staticClass:"note"},[_c('small',[_vm._t("note")],2)]),_c('div',{staticClass:"errmsg"},[_c('small',[_vm._v(_vm._s(_vm.message))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }